import { AddressesState } from './partials/addresses'
import { EmailsState } from './partials/emails'
import { PartyEditState } from './partials/party-edit'
import { PartyMergeState } from './partials/party-merge'
import { PartySurveysPageState } from './partials/party-surveys-page'
import { PartyTagState } from './partials/party-tag'
import { PhonesState } from './partials/phones'
import { ResidenceHistoriesState } from './partials/residence-histories'

export const PartyState = _ => ({
  ...AddressesState,
  ...EmailsState,
  ...PartyEditState,
  ...PartyMergeState,
  ...PartyTagState,
  ...PhonesState,
  ...ResidenceHistoriesState,
  ...PartySurveysPageState,
  currentParty: null,
  parties: [],
  saveAddressesTriggered: false,
  saveEmailsTriggered: false,
  savePhonesTriggered: false,
  saveResidenceHistoriesTriggered: false,
  isSearching: false,
})
